import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/Button";
import { fillMarqueeTrack } from "@/utils/fillMarqueeTrack.js";

/**
 * PhotosMarquee Component
 * Customer photos infinite scrolling marquee
 */
export function PhotosMarquee() {
  const trackRef = useRef(null);
  const assetsUrl = `${window.template_root}/src/public/`;

  const acfData = window.post_template || [];
  const ctaLink = window.cta_link || "#";

  const photos = [
    `${assetsUrl}img/marquee/1.jpg`,
    `${assetsUrl}img/marquee/2.jpg`,
    `${assetsUrl}img/marquee/3.jpg`,
    `${assetsUrl}img/marquee/4.jpg`,
    `${assetsUrl}img/marquee/5.jpg`,
    `${assetsUrl}img/marquee/6.jpg`,
    `${assetsUrl}img/marquee/7.jpg`,
    `${assetsUrl}img/marquee/8.jpg`,
    `${assetsUrl}img/marquee/9.jpg`,
  ];

  // Clone items for infinite loop effect
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    return fillMarqueeTrack(track);
  }, []);

  return (
    <section
      className="relative overflow-hidden p-0 bg-white max-md:p-0"
      aria-label="Customer photos"
    >
      {/* CTA Button - Centered */}
      <Button
        href={ctaLink}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10
                   bg-secondary backdrop-blur-[15px] !text-green rounded-[99rem]
                   py-4 px-8 font-[480] text-[1.05rem] cursor-pointer
                   transition-all shadow-[0_6px_24px_rgba(0,0,0,0.3)]
                   hover:-translate-x-1/2 hover:-translate-y-[calc(50%+2px)]
                   active:-translate-x-1/2 active:-translate-y-1/2
                   max-md:py-3 max-md:px-7 max-md:text-base"
      >
        {acfData.tr_cta_text}
      </Button>

      {/* Photos Container */}
      <div className="w-full overflow-hidden flex items-center">
        <div
          ref={trackRef}
          className="inline-flex items-center gap-0 flex-nowrap whitespace-nowrap animate-marquee-photos"
        >
          {photos.map((photo, index) => (
            <img
              key={index}
              src={photo}
              alt=""
              className="w-[220px] h-[220px] object-cover flex-shrink-0 max-md:w-[160px] max-md:h-[160px]"
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default PhotosMarquee;
